import { render, staticRenderFns } from "./profile-info.vue?vue&type=template&id=41bccbb2&scoped=true&"
import script from "./profile-info.vue?vue&type=script&lang=js&"
export * from "./profile-info.vue?vue&type=script&lang=js&"
import style0 from "./profile-info.vue?vue&type=style&index=0&id=41bccbb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bccbb2",
  null
  
)

export default component.exports